import { render, staticRenderFns } from "./NewReferenceModal.vue?vue&type=template&id=e70aeb34"
import script from "./NewReferenceModal.vue?vue&type=script&lang=js"
export * from "./NewReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./NewReferenceModal.vue?vue&type=style&index=0&id=e70aeb34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports